import React, { Component } from 'react'
import './headerLine.css'

class HeaderLine extends Component {
   
    render(){
        return(
            <div className="headerline-container">
                <p className="paragraph">{this.props.header}</p>
            </div>
        )
    }
}

export default HeaderLine